import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  onResetFoodDetail,
  onResetSimilarFoodLists,
  fetchSimilarFoodSearch,
  changeRecommendFood,
  fetchRecommendMeal,
} from "../../../../features/mobile/recommendSlice";
import SimilarFoodCard from "./SimilarFoodCard";
// import Btn from "../common/Btn";
import LikeBtns from "../common/LikeBtns";
import { useEffect } from "react";
// import BookmarkBtn from '../common/BookmarkBtn';

const FoodDetailDialog = ({
  openFoodDialog,
  setOpenFoodDialog,
  shareState,
  setLoading,
  recipeHidden,
}) => {
  const dispatch = useDispatch();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const { foodDetailStatus, foodDetail, isExistRecipe, similarFoodLists } =
    useSelector((state) => state.recommend);
  const [chosenOne, setChosenOne] = useState({
    id: null,
    eyemesurementnumber: null,
    foodName: "",
  });
  // const [openTab, setOpenTab] = useState(false);
  const [showMenuChange, setShowMenuChange] = useState(false);
  const [menuChangeErrorMsg, setMenuChangeErrorMsg] = useState(false);
  const [checkText, setCheckText] = useState("");
  const [checkColor, setCheckColor] = useState("");
  const [checkHeight, setCheckHeight] = useState(" h-[500px] ");
  const [miniHeight, setMiniHeight] = useState(" h-[380px] ");
  const [checkAni, setCheckAni] = useState("animate-rightSlide");
  const cpf = [
    {
      name: "Carbs",
      keyName: "carbohydratesG",
      unit: "g",
      bgColor: "bg-[#73C07A]",
    },
    { name: "Protein", keyName: "proteinG", unit: "g", bgColor: "bg-[#F68282]" },
    { name: "Fat", keyName: "fatG", unit: "g", bgColor: "bg-[#FFD442]" },
  ];
  const nutri = [
    { name: "Dietary Fiber", keyName: "totalDietaryfiberG", unit: "g" },
    { name: "Sugars", keyName: "totalsugarG", unit: "g" },
    { name: "Saturated Fat", keyName: "totalSaturatedfattyacidG", unit: "g" },
    { name: "Sodium", keyName: "sodiumMG", unit: "mg" },
    { name: "Cholesterol", keyName: "cholesterolMG", unit: "mg" },
    { name: "Trans Fat", keyName: "transfattyacidG", unit: "g" },
  ];
  const navigate = useNavigate();

  const cpfReturn = (el) => {
    return (
      <>
        <span className={"block h-2 w-2 rounded-full " + el.bgColor}></span>
        <span>
          {el.name}{" "}
          {parseInt(foodDetail[el.keyName]) !== null
            ? parseInt(foodDetail[el.keyName])
            : "-"}
          {el.unit}
        </span>
      </>
    );
  };

  const foodTypeEmoji = (foodDetail) => {
    return (
      <>
        {foodDetail ? (
          <span>
            {foodDetail.rice === 2
              ? "🍚"
              : foodDetail.soup === 2
              ? "🍲"
              : foodDetail.protein === 2
              ? "🍖"
              : foodDetail.vegetable === 2
              ? "🥗"
              : foodDetail.kimchi === 2
              ? "🌶"
              : foodDetail.snack === 2
              ? "🍎"
              : "🍚"}
          </span>
        ) : null}
      </>
    );
  };

  const onCloseDialog = () => {
    setOpenFoodDialog({
      open: false,
      id: null,
      foodId: null,
      mealDate: null,
      mealType: null,
    });
    setShowMenuChange(false);
    // setOpenTab(false);
    setMenuChangeErrorMsg(false);
    const timer = setTimeout(() => {
      if (foodDetail?.id) dispatch(onResetFoodDetail());
      if (similarFoodLists?.length > 0) dispatch(onResetSimilarFoodLists());
    }, 300);
    return () => clearTimeout(timer);
  };

  const onOpenMenuChange = () => {
    window.dataLayer.push({
      event: "change_from_food",
      food_id: foodDetail?.foodId,
      food_name: foodDetail?.foodName,
    });

    let params = { userId: loginInfo.userId, foodId: openFoodDialog.id };
    dispatch(fetchSimilarFoodSearch(params))
      .unwrap()
      .then((res) => {
        if (!res.ok) {
          setMenuChangeErrorMsg(res.error);
        }
      })
      .catch((err) => console.log(err));
    setChosenOne({ id: null, eyemesurementnumber: null });
    setShowMenuChange(true);
  };

  const onSaveChangedMenu = () => {
    window.dataLayer.push({
      event: "selected_food_name",
      food_id: chosenOne.id,
      food_name: chosenOne.foodName,
    });

    if (menuChangeErrorMsg) {
      onCloseDialog();
    } else {
      let params = {
        userId: loginInfo.userId,
        orgFoodId: openFoodDialog.id,
        changeFoodId: chosenOne.id,
        eyemesurementnumber: chosenOne.eyemesurementnumber,
      };
      setLoading(false);
      dispatch(changeRecommendFood(params))
        .unwrap()
        .then(() =>
          dispatch(fetchRecommendMeal({ userId: loginInfo.userId }))
            .unwrap()
            .then(() => setLoading(true))
        )
        .catch((err) => console.log(err));
    }
    setChosenOne({ id: null, eyemesurementnumber: null, foodName: "" });
    onCloseDialog();
  };

  const onBackMenu = () => {
    // * Animation sliding right when going back
    setCheckAni("animate-leftSlide");
    // setShowMenuChange(true);
    // * Timing matched to event duration
    setTimeout(() => {
      setShowMenuChange(false);
      setCheckAni("animate-rightSlide");
    }, 400);

    // console.log("executed");
  };

  useEffect(() => {
    setCheckColor("");
    setCheckText("");
    if (foodDetail && foodDetail.contentunit === "g") {
      const SodiumRisk = (foodDetail.sodiumMG / foodDetail.servingsize) * 100;
      if (foodDetail.sodiumMG === null) {
        setCheckText("-");
      } else if (SodiumRisk < 120) {
        setCheckColor("text-green_120");
        setCheckText("Low");
      } else if (SodiumRisk >= 120 && SodiumRisk <= 600) {
        setCheckColor("text-yellow_160");
        setCheckText("Medium");
      } else if (SodiumRisk > 600) {
        setCheckColor("text-orange_180");
        setCheckText("High");
      }
    } else if (
      foodDetail &&
      (foodDetail.contentunit === "mL" || foodDetail.contentunit === "ml")
    ) {
      const SodiumRisk = (foodDetail.sodiumMG / foodDetail.servingsize) * 100;
      if (foodDetail.sodiumMG === null) {
        setCheckText("-");
      } else if (SodiumRisk < 120) {
        setCheckColor("text-green_120");
        setCheckText("Low");
      } else if (SodiumRisk >= 120 && SodiumRisk <= 300) {
        setCheckColor("text-yellow_160");
        setCheckText("Medium");
      } else if (SodiumRisk > 300) {
        setCheckColor("text-orange_180");
        setCheckText("High");
      }
    }
    if (
      checkText !== "Low" &&
      foodDetail &&
      foodDetail.foodType !== "Rice" &&
      !foodDetail.foodType.includes("Snack") &&
      foodDetail.foodType !== "Porridge" &&
      foodDetail.foodType !== "죽"
    ) {
      setCheckHeight(" h-[500px] ");
      setMiniHeight(" h-[380px] ");
    } else {
      setCheckHeight(" h-[440px] ");
      setMiniHeight(" h-[320px] ");
    }
  }, [foodDetail, checkText, openFoodDialog]);

  return (
    <>
      <div
        onClick={onCloseDialog}
        className={
          openFoodDialog.open
            ? "fixed left-0 top-0 z-10 h-full w-full bg-black opacity-70"
            : ""
        }
      ></div>
      {/* { */}
      {/* !showMenuChange ? ( */}
      <div
        className={
          `fixed z-20 flex-col items-start rounded-t-[32px] bg-white py-[32px]  duration-700 ${checkHeight} maxW left-0 right-0 isolate mx-auto gap-6 ` +
          (window.innerWidth <= 368
            ? "px-[15px] "
            : window.innerWidth <= 372
            ? "px-[20px] "
            : window.innerWidth <= 376
            ? "px-[22px] "
            : "px-[24px] ") +
          // (checkText !== "Low" &&
          // foodDetail &&
          // foodDetail.foodType !== "Rice" &&
          // !foodDetail.foodType.includes("Snack") &&
          // foodDetail.foodType !== "죽"
          //   ? "h-[500px] "
          //   : "h-[440px] ") +
          (openFoodDialog.open
            ? "bottom-0"
            : foodDetail &&
              foodDetail.foodType !== "Rice" &&
              !foodDetail.foodType.includes("Snack") &&
              foodDetail.foodType !== "Porridge" &&
              foodDetail.foodType !== "죽"
            ? "bottom-[-500px]"
            : "bottom-[-500px]")
          // : 'bottom-[-440px]')

          // ? "bottom-[-620px]"
          // : "bottom-[-540px]"
        }
      >
        <div
          className="bgCover rounded-t-[32px]"
          // style={{
          //   background: `url('${
          //     foodDetail?.representativeImage
          //       ? foodDetail?.representativeImage
          //       : "/images/mobile/image/no_image.svg"
          //   }') no-repeat center`,
          // }}
        >
          <img
            src="/images/mobile/icon/close.svg"
            alt="Close"
            className="absolute right-6 top-6"
            onClick={onCloseDialog}
          />
        </div>
        {foodDetailStatus === "success" && foodDetail?.foodId ? (
          // <div className="flex flex-col items-center w-full gap-2 ">
          <div>
            <div className="flex flex-col items-start gap-1.5">
              <span
                id="foodName"
                className="items-center text-xl font-semibold text-black leading-tight"
              >
                {foodDetail.foodName}
              </span>
              <ul className="order-1 flex w-full flex-row flex-wrap items-center gap-x-2 gap-y-1">
                <li className="text-sm text-gray_160">
                  Total {foodDetail.servingsize || "-"}
                  {foodDetail.contentunit}
                </li>
                <li className="text-gray_40">|</li>
                <li className="text-sm text-gray_160">
                  {foodDetail.eyemesurementnumber || "-"}
                  {foodDetail.eyemesurementunit}
                </li>
                <li className="text-gray_40">|</li>
                <li className="text-sm text-gray_160">
                  {foodDetail.kcal || "-"}kcal
                </li>
                <li className="text-gray_40">|</li>
                <li className="flex items-center gap-1">
                  <span className="text-sm text-gray_160">Sodium</span>
                  <span className={` ${checkColor} text-sm font-semibold `}>
                    {checkText}
                  </span>
                </li>
              </ul>
            </div>
            {shareState !== true ? (
              <div className="z-10 order-1 flex flex-row items-center justify-between gap-2 py-4">
                <div
                  typeof="button"
                  className={
                    " box-border flex flex-row items-center justify-center gap-1.5 rounded-full border border-main bg-main py-1.5 px-3 " +
                    (recipeHidden && " pointer-events-none opacity-50 ")
                  }
                  onClick={onOpenMenuChange}
                >
                  <img
                    src="/images/mobile/icon/arrow_left_right.svg"
                    alt="Swap icon"
                    className="w-4 h-4"
                  />
                  <span className="order-1 flex items-center text-center text-sm font-semibold text-white">
                    Change Food
                  </span>
                </div>
                <div
                  typeof="button"
                  className={
                    "order-1 box-border flex flex-row items-center justify-center gap-1.5 rounded-full border bg-white py-1.5 px-3" +
                    (isExistRecipe ? " border-[#5CCFFE]" : " border-gray_100")
                  }
                  onClick={
                    isExistRecipe
                      ? () => navigate(`/recommend/recipe/${foodDetail.foodId}`)
                      : null
                  }
                >
                  <img
                    src={
                      isExistRecipe
                        ? "/images/mobile/icon/recipe_icon.svg"
                        : "/images/mobile/icon/recipe_none_icon.svg"
                    }
                    alt="Recipe icon"
                    className="w-4 h-4"
                  />
                  <span
                    className={
                      "flex items-center text-center text-sm font-semibold " +
                      (isExistRecipe ? " text-[#5CCFFE] " : " text-gray_100 ")
                    }
                  >
                    Recipe
                  </span>
                </div>

                <LikeBtns
                  option={"food"}
                  checkStatus={foodDetail.like}
                  id={foodDetail.foodId}
                  foodName={foodDetail.foodName}
                  marginR=" order-2 "
                  // likeTitle={"Like this food"}
                />
                {/* <ul className="flex flex-row items-center  justify-end gap-[11px] order-2 ]">
                  <LikeBtns
                    option={"food"}
                    checkStatus={foodDetail.like}
                    id={foodDetail.foodId}
                    marginR="  "
                    // likeTitle={"Like this food"}
                  />
                </ul> */}
                {/* <BookmarkBtn option={'food'} checkStatus={foodDetail.bookmark} id={foodDetail.foodId} title={'Bookmark'} /> */}
              </div>
            ) : shareState === true && isExistRecipe ? (
              <div className="flex py-4">
                <div
                  typeof="button"
                  className={
                    "order-1 box-border flex flex-row items-center justify-center gap-1.5 rounded-full border bg-white py-1.5 px-3" +
                    (isExistRecipe ? " border-orange_140" : " border-gray_100")
                  }
                  onClick={
                    isExistRecipe && shareState === true
                      ? () =>
                          navigate(
                            `/recommend/recipe/share/${foodDetail.foodId}`
                          )
                      : isExistRecipe
                      ? () => navigate(`/recommend/recipe/${foodDetail.foodId}`)
                      : null
                  }
                >
                  <img
                    src={
                      isExistRecipe
                        ? "/images/mobile/icon/recipe_icon.svg"
                        : "/images/mobile/icon/recipe_none_icon.svg"
                    }
                    alt="Recipe icon"
                    className="w-4 h-4"
                  />
                  <span
                    className={
                      "flex items-center text-center text-sm font-semibold " +
                      (isExistRecipe ? " text-orange_140 " : " text-gray_100 ")
                    }
                  >
                    Recipe
                  </span>
                </div>
              </div>
            ) : (
              <div className="flex py-4"></div>
            )}

            {foodDetail.rice !== 2 && foodDetail.snack !== 2 ? (
              <div className="z-20 order-2 mb-4 flex flex-col items-start gap-1.5 self-stretch rounded-lg bg-gray_15 p-3">
                <span className="flex items-center text-sm text-gray_200">
                  {foodDetail.soup === 2
                    ? "🍲 Soup & Stew"
                    : foodDetail.protein === 2
                    ? "🍖 Protein Side Dish"
                    : foodDetail.vegetable === 2
                    ? "🥗 Vegetables Side Dish"
                    : foodDetail.kimchi === 2
                    ? "🌶 Kimchi"
                    : "🍚 Special Menu"}
                </span>
                {checkText !== "Low" ? (
                  <span className="order-1 self-stretch text-sm text-gray_160 leading-relaxed">
                    {foodDetail.soup === 2
                      ? "For soup, focus on eating the solid ingredients and leaving the broth to reduce sodium intake by 1/3."
                      : foodDetail.protein === 2 || foodDetail.vegetable === 2
                      ? "When making side dishes, using soy sauce instead of salt, and using soybean or chili paste instead of soy sauce can reduce sodium."
                      : foodDetail.kimchi === 2
                      ? "Cutting kimchi into small pieces and eating less can reduce sodium intake."
                      : "Reducing salt during cooking and enhancing natural flavors can reduce sodium intake."}
                  </span>
                ) : null}
              </div>
            ) : (
              <div className="z-20 order-2 mb-4 flex flex-col items-start gap-1.5 self-stretch rounded-lg bg-gray_15 p-3">
                <span className="flex items-center text-sm text-gray_200">
                  {foodDetail.rice === 2
                    ? "🍚 Rice"
                    : foodDetail.snack === 2
                    ? "🍎 Snack"
                    : "🍚"}
                </span>
              </div>
            )}

            <div className="z-30 order-3 flex flex-col items-start gap-1.5 self-stretch rounded-lg bg-gray_15 p-3">
              <div className="flex flex-row items-center gap-3 self-stretch">
                <ul className="flex flex-row items-start gap-3">
                  {cpf.map((el, idx) => (
                    <li
                      key={idx}
                      className="flex items-center gap-1 text-sm"
                    >
                      {cpfReturn(el)}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="order-1 flex flex-col items-start gap-3 self-stretch py-1 pr-2">
                <ul className="grid grid-flow-col grid-rows-3 items-start self-stretch text-sm text-gray_160">
                  {nutri.map((el, idx) => (
                    <li key={idx}>
                      <span>• {el.name}:</span>
                      <span>
                        {" "}
                        {foodDetail[el.keyName] !== null
                          ? foodDetail[el.keyName]
                          : "-"}
                        {el.unit}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {showMenuChange ? (
        <div
          className={
            ` maxW fixed left-0 right-0 z-20 mx-auto rounded-t-[32px] bg-white ${checkHeight} ${checkAni} ` +
            (openFoodDialog.open ? "bottom-0" : "bottom-[-500px]")
          }
        >
          <ul className="flex cursor-pointer items-center justify-between py-2 pl-4 pr-2 ">
            <li className="flex items-center gap-2">
              <img
                src="/images/mobile/icon/back_btn.svg"
                alt="Back button"
                onClick={onBackMenu}
              />
            </li>
            <li className="order-1">
              <h2 className="text-caption1_400 text-gray_200">
                {foodDetail && foodTypeEmoji(foodDetail)}{" "}
                {foodDetail
                  ? foodDetail.soup === 2
                    ? "Soup & Stew"
                    : foodDetail.protein === 2
                    ? "Protein Side Dish"
                    : foodDetail.vegetable === 2
                    ? "Vegetables Side Dish"
                    : foodDetail.kimchi === 2
                    ? "Kimchi"
                    : foodDetail.rice === 2
                    ? "Rice"
                    : foodDetail.snack === 2
                    ? "Snack"
                    : "Special Menu"
                  : "-"}
              </h2>
            </li>
            <li className="order-2">
              <img
                onClick={onCloseDialog}
                src="/images/mobile/icon/close.svg"
                alt="Close icon"
              />
            </li>
          </ul>

          <div
            className={`pb-[24px] pt-2 ${miniHeight} order-1 overflow-y-scroll px-[24px]`}
          >
            {/* <div className="flex items-center justify-between gap-2 pb-2 border-b border-gray_90">
              <h2 className="text-black text-subtitle1">
                {foodDetail.foodName}
              </h2>
              <h5 className="text-body2_600 text-gray_140">
                {foodDetail.eyemesurementnumber || ""}{" "}
                {foodDetail.eyemesurementunit || "ea"}
              </h5>
            </div> */}

            {!menuChangeErrorMsg && (
              <p className="mt-2 text-caption1_400 text-gray_200">
                Instead of{" "}
                <span className="text-caption1_700 text-black">
                  '{foodDetail && foodDetail.foodName}'
                </span>
                , here are foods recommended in order of
                <span className="text-caption1_600"> low sodium </span>
                content.
                <br />
                Please select the food you prefer.
              </p>
            )}
            {similarFoodLists && similarFoodLists?.length > 0 ? (
              <div className="mb-1 mt-4 flex flex-col gap-3">
                {similarFoodLists.map((food) => (
                  <SimilarFoodCard
                    key={food.id}
                    chosenOne={chosenOne}
                    setChosenOne={setChosenOne}
                    food={food}
                  />
                ))}
              </div>
            ) : null}
            {menuChangeErrorMsg && (
              <p className="body2_500 mt-2 text-center text-gray_160">
                {menuChangeErrorMsg}
              </p>
            )}
          </div>

          {/* <Btn
            option={"bottom"}
            bgColor={"bg-main"}
            textColor={"text-white"}
            borderColor={"border border-main"}
            title={menuChangeErrorMsg ? "OK" : "Change to selected food"}
            active={menuChangeErrorMsg || chosenOne.id ? "on" : "ready"}
            onAction={onSaveChangedMenu}
          /> */}

          <div className="maxW fixed bottom-0 left-0 right-0 mx-auto items-center justify-center text-center text-white ">
            <button
              className={
                " w-full gap-[2px] p-4 text-body3_700  " +
                (menuChangeErrorMsg || chosenOne.id
                  ? " border-main bg-main text-white active:border-blue-600 active:bg-blue-600 "
                  : " bg-blue-300 text-white ")
              }
              onClick={(e) => {
                if (menuChangeErrorMsg || chosenOne.id) {
                  if (menuChangeErrorMsg === "No alternative menu available.") {
                    onBackMenu(e);
                  } else {
                    onSaveChangedMenu(e);
                  }
                }
              }}
            >
              <span className="text-body3_700 text-white">
                {menuChangeErrorMsg === "No alternative menu available."
                  ? "OK"
                  : "Change Food"}
              </span>
            </button>
          </div>
        </div>
      ) : null}
      {/* )  */}
    </>
  );
};

export default FoodDetailDialog;
